// extracted by mini-css-extract-plugin
export default {"login_container":"seller_login_container__CKxYz"};